module.exports = __webpack_public_path__ + "static/media/english_dictionary_icon_store.58e6eb5b.png";